// Reports persist their column metadata in `result`, so ones generated before the
// Font Awesome 6 upgrade still carry FA4 icon classes.
const LEGACY_REPORT_ICONS = {
  'fa-file-text-o': 'fa-regular fa-file-lines',
  'fa-external-link': 'fa-solid fa-up-right-from-square',
};

export const urlHelperMixin = {
  methods: {
    urlForProfile(profile_id, profile_type) {
      if (profile_type === 'ParentProfile') {
        return `/parents/${profile_id}`;
      }
      if (profile_type === 'CoachProfile') {
        return `/coaches/${profile_id}`;
      }
      if (profile_type === 'WrestlerProfile') {
        return `/wrestlers/${profile_id}`;
      }

      return '';
    },
    // Attempt to detect urls in text and anchor tag it
    urlify(text, includeBreaks, iconClass) {
      const urlRegex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi;
      const linkedText = text.replace(urlRegex, (url) => {
        const icon = LEGACY_REPORT_ICONS[iconClass] || iconClass;
        const linkContent = icon ? `<i class="${icon}"></i>` : url;
        return `<a href="${url}" target="_blank">${linkContent}</a>`;
      });
      const lineBreak = includeBreaks ? '<br>' : '';
      return `${linkedText}${lineBreak}`;
    },
    // Render plain message `content` for a v-html sink: linkify URLs and convert
    // raw newlines to <br>, since HTML collapses them and multi-line plain
    // messages (composer plain path, inbound SMS) would flatten to one line.
    plainContentHtml(text) {
      return this.urlify(text, true, null).replace(/\n/g, '<br>');
    },
  },
};
